/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import appleFilled from '@iconify/icons-ant-design/apple-filled';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import CountUp from 'react-countup';
import TokenDecoder from '../../../helpers/TokenDecoder';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import VPUDashboardService from './VPUDashboardService'


// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: 'none',
    textAlign: 'center',
    padding: theme.spacing(5, 0),
    color: theme.palette.info.darker,
    backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette.info.dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
        theme.palette.info.dark,
        0.24
    )} 100%)`
}));

// ----------------------------------------------------------------------

// const TOTAL = 1352831;



export default function OrderCountQtywiseVPU() {


    // const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);

    const [productQuantity, setProductQuantity] = useState(0);

    async function getYesterdayOrderCountQty() {
        const response = await VPUDashboardService.getYesterdayOrderCountQty();
        if (response.length > 0) {
            setProductQuantity(response[0].productQuantity);
        }
    }

    useEffect(() => {
        getYesterdayOrderCountQty();
    }, [])

    return (
        <RootStyle>
            <IconWrapperStyle>
                {/* <Icon icon={appleFilled} width={24} height={24} /> */}
                < ReceiptLongIcon fontSize='large' width={50} height={60} />
            </IconWrapperStyle>
            <Typography variant="h3"><CountUp end={productQuantity} separator=',' decimals={2} /></Typography>
            <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                Customer Order Count (kg)
            </Typography>
        </RootStyle>
    );
}
